import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";

const Accessibility = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-16 px-4 mt-10">
        <div className="max-w-4xl mx-auto">
          <motion.h1
            className="text-3xl sm:text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-400 mb-4"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Accessibility Statement
          </motion.h1>

          <p className="text-sm text-gray-500 text-center mb-8">Committed to an accessible web experience</p>

          <div className="bg-white rounded-2xl shadow-md p-6 space-y-6">
            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">Our Commitment</h2>
              <p className="text-gray-600 leading-relaxed">
                HLC is committed to providing a website that is accessible to the widest possible audience, regardless of technology or ability. We aim to conform with relevant accessibility standards.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Accessibility Features</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Semantic HTML and ARIA where appropriate</li>
                <li>Keyboard navigable menus and forms</li>
                <li>High-contrast visuals and adjustable text size where possible</li>
                <li>Alt text for informative images</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Limitations</h3>
              <p className="text-gray-600 leading-relaxed">
                While we work continuously to improve accessibility, some third-party content or older pages may not fully meet best practices. We welcome feedback to help us improve.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Feedback & Assistance</h3>
              <p className="text-gray-600 leading-relaxed">
                If you encounter accessibility barriers, please contact us at <strong>accessibility@hlc.com</strong> with details. We will respond within a reasonable timeframe and offer an alternative way to access information.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Accessibility;
